import md5 from "@/assets/utils/md5";
import common from "@/assets/utils/commom";

// 员工相关接口
export default function (axios) {
  return {
    //--------------------------------------------------------------------设置：成员
    // // 设为管理员
    // setAdmin(params) {
    //   let url = "/compStaffMember/setStaffAdmin"; //新增
    //   return axios.post(url, {}, { params });
    // },

    //--------------------------------------------------------------------设置：职位职级

    // 新增/编辑员工的备注与描述
    editStaffRemarksApi(params) {
      return axios.post("/remarks/editStaffRemarks", params);
    },
    // 人员的备注和描述回显
    getStaffContractApi(params) {
      return axios.post("/remarks/getStaffContract", params);
    },
    // 查询有员工的部门 / 供应商
    selectExistStaffApi() {
      return axios.get("/remarks/selectExistStaff");
    },
  };
}
